import React, { useEffect, useContext, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';
import {
  Box,
  Grid,
  Typography,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

function ModalPapirTicketNotSold() {
  const { t } = useTranslation();

  const {
    updateFocusOnMainScreen,
    updateShowModalPapirTicketNotSold,
    updatePapirScannedInfo,
    papirScannedInfo,
  } = useContext(AppContext);

  const papirScannedInfoRef = useRef(papirScannedInfo);
  useEffect(() => {
    papirScannedInfoRef.current = papirScannedInfo;
  }, [papirScannedInfo]);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {}, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const confirmClose = async () => {
    updatePapirScannedInfo(false);
    updateFocusOnMainScreen(true);
    updateShowModalPapirTicketNotSold(false);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.papirTicketNotSoldTitle')} </h1>
            <p>{t('sales.papirTicketNotSoldText1')}</p>
            {/*<p>{t('sales.papirTicketNotSoldText2')}</p>*/}

            {papirScannedInfoRef.current &&
              papirScannedInfoRef.current.historic.length > 0 && (
                <>
                  <p>{t('sales.papirTicketNotSoldText3')}</p>
                  <Paper
                    sx={{
                      flexGrow: 1,
                      border: 1,
                      borderColor: '#e5e7eb',
                      bgcolor: '#232a45',
                      borderRadius: 2,
                      boxShadow: 2,
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column',
                      maxHeight: 450,
                    }}
                  >
                    <TableContainer sx={{ flexGrow: 1, overflowY: 'auto' }}>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              {t('sales.papirTicketDate')}
                            </TableCell>
                            <TableCell align="center">
                              {t('sales.papirTicketGameID')}
                            </TableCell>
                            <TableCell align="center">
                              {t('sales.papirTicketTransaction')}
                            </TableCell>
                            <TableCell align="center">
                              {t('sales.papirTicketAmount')}
                            </TableCell>
                            <TableCell align="center">
                              {t('sales.papirTicketPrizes')}
                            </TableCell>
                            <TableCell align="center">
                              {t('sales.papirTicketPrizesPayout')}
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {papirScannedInfoRef.current.historic.length > 0 &&
                            papirScannedInfoRef.current.historic.map(
                              (ticket, i) => (
                                <TableRow key={i}>
                                  <TableCell align="center">
                                    {ticket.date}
                                  </TableCell>
                                  <TableCell align="center">
                                    {ticket.gameID}
                                  </TableCell>
                                  <TableCell align="center">
                                    {ticket.transID === 12
                                      ? t('sales.papirTicketSold')
                                      : ticket.transID === 11
                                        ? t('sales.papirTicketPrizes')
                                        : ticket.transID === 14
                                          ? t('sales.papirTicketCancel')
                                          : '-'}
                                  </TableCell>
                                  <TableCell align="center">
                                    {ticket.amount}
                                  </TableCell>
                                  <TableCell align="center">
                                    {ticket.prize === '' ? '-' : ticket.prize}
                                  </TableCell>
                                  <TableCell align="center">
                                    {ticket.isPayedOut ? 'V' : '-'}
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </>
              )}
            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              <button
                className="btn-custom-yes"
                onClick={() => {
                  confirmClose();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                {t('sales.confirm')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalPapirTicketNotSold;
